import * as React from "react"

// Card component with inline styles compatible with existing CSS
const Card = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className = '', style, ...props }, ref) => (
  <div
    ref={ref}
    className={`shadcn-card ${className}`}
    style={{
      borderRadius: '0.5rem',
      border: '1px solid rgba(255, 255, 255, 0.1)',
      background: 'rgba(255, 255, 255, 0.05)',
      boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
      ...style
    }}
    {...props}
  />
))
Card.displayName = "Card"

const CardHeader = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className = '', style, ...props }, ref) => (
  <div
    ref={ref}
    className={`shadcn-card-header ${className}`}
    style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '0.375rem',
      padding: '1.5rem',
      ...style
    }}
    {...props}
  />
))
CardHeader.displayName = "CardHeader"

const CardTitle = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLHeadingElement>
>(({ className = '', style, ...props }, ref) => (
  <h3
    ref={ref}
    className={`shadcn-card-title ${className}`}
    style={{
      fontSize: '1.5rem',
      fontWeight: 600,
      lineHeight: '1',
      letterSpacing: '-0.025em',
      color: '#ffffff',
      ...style
    }}
    {...props}
  />
))
CardTitle.displayName = "CardTitle"

const CardDescription = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ className = '', style, ...props }, ref) => (
  <p
    ref={ref}
    className={`shadcn-card-description ${className}`}
    style={{
      fontSize: '0.875rem',
      color: 'rgba(255, 255, 255, 0.6)',
      ...style
    }}
    {...props}
  />
))
CardDescription.displayName = "CardDescription"

const CardContent = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className = '', style, ...props }, ref) => (
  <div 
    ref={ref} 
    className={`shadcn-card-content ${className}`}
    style={{
      padding: '1.5rem',
      paddingTop: '0',
      ...style
    }}
    {...props} 
  />
))
CardContent.displayName = "CardContent"

const CardFooter = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className = '', style, ...props }, ref) => (
  <div
    ref={ref}
    className={`shadcn-card-footer ${className}`}
    style={{
      display: 'flex',
      alignItems: 'center',
      padding: '1.5rem',
      paddingTop: '0',
      ...style
    }}
    {...props}
  />
))
CardFooter.displayName = "CardFooter"

export { Card, CardHeader, CardFooter, CardTitle, CardDescription, CardContent }

